import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Link } from '@components/Link';

const Swatches = ({
  label,
  attributes,
  activeAttribute,
  wrapperClassName,
  listClass,
  itemHandler,
  indicateSale,
  showActiveAttribute = true,
  hideLabel = false,
}) => {
  const swatchHref = (swatch) => {
    let href = '#';

    if (!activeAttribute || swatch.id !== activeAttribute.id) {
      href = swatch.url;
    }

    return href;
  };

  const swatchChangeHandler = (swatch) => (e) => {
    e.preventDefault();

    itemHandler(swatch)();
  };

  const renderedSwatches = useMemo(() => {
    return attributes.map((swatch) => (
      <div key={swatch.id} className='option-container'>
        {indicateSale && swatch.maxAdditionalSalePercent > 0 && <div className='discount-ribbon'>SALE</div>}
        <Link
          key={swatch.id}
          className={classNames('option', {
            active: activeAttribute?.id === swatch.id,
            disabled: !swatch.isAvailable,
            'out-of-stock': !swatch.isInStock,
          })}
          href={swatchHref(swatch)}
          onClick={swatchChangeHandler(swatch)}>
          {swatch.formattedValue}
        </Link>
      </div>
    ));
  }, [attributes, activeAttribute]);

  return (
    <div className={`variant-selectors ${wrapperClassName || `product-${label}s`}`}>
      <div className='row align-items-center'>
        <div className='col-12'>
          <div className='product-swatches-header'>
            <div className='product-swatches-title'>
              {!hideLabel && <span className='title'>{label}</span>}{' '}
              <i className='selected-variant'>
                {activeAttribute
                  ? showActiveAttribute
                    ? `${activeAttribute.value}`
                    : null
                  : `Select ${label.toLowerCase()}`}
                {activeAttribute ? (
                  !activeAttribute.isInStock ? (
                    <b> - Out Of Stock</b>
                  ) : !activeAttribute.isAvailable ? (
                    <b> - Unavailable</b>
                  ) : null
                ) : null}
              </i>
            </div>
          </div>
        </div>
        <div className='col-12'>
          <div
            className={`product-detail-selector d-block d-md-inline-block ${listClass ? listClass : label}`}>
            {renderedSwatches}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Swatches;
